export default "__VITE_ASSET__0d3f5e43__"